import gql from 'graphql-tag';

import DAILY_EXPANDED_FRAGMENT from './DAILY_EXPANDED_FRAGMENT';

/*

IMPORTANT - this mutation is only used by daily view. It returns the expanded
daily fragment so the caller can update the detailed run state without issuing a
second getServiceRun query after every drag/drop.

Note: this is not currently used anywhere else besides daily view. If it was, it would
be better to create another mutation, and make this one DAILY_ONLY.

*/


const ADD_MACHINE_TO_SERVICE_RUN = gql`

	mutation addMachineToServiceRun (
		$machineId: ID!,
		$serviceRunId: ID!,
		$order: Int,
	) {
		addMachineToServiceRun (
			machineId: $machineId,
			serviceRunId: $serviceRunId,
			order: $order,
		) {
			...serviceRunDailyExpanded

		}
	}
	${DAILY_EXPANDED_FRAGMENT}

`;

export default ADD_MACHINE_TO_SERVICE_RUN;
